import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';
import { TypedMemo } from '../common/types';
import { SMLContainer } from '../smartLinks/smlContainer/SMLContainer';
import { SMLRouteNames, SMLRoutes } from '../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../routing/sml/hooks';
import { SMLDatePicker } from './components/SMLDatePicker/SMLDatePicker';
import { TrackSearchField, MeiliTrackData } from './components/SearchField';
import { TopGainingTracksCard } from './components/TopGainingTracksCard/TopGainingTracksCard';
import { TopOverallTracksCard } from './components/TopOverallTracksCard/TopOverallTracksCard';
import { ChartsPageHead } from './charts/ChartsPageHead';
import { PageTabsInBody } from './components/SMLPageHead/PageTabsInBody';
import { ChartsTabRow } from './charts/ChartsTabRow';

const SMLTracksHomeComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();

  // Handle track selection from search - navigate to track details
  const handleTrackSelected = useCallback(
    (track: MeiliTrackData) => {
      router.push(SMLRoutes.trackDetails, { trackId: track.id });
    },
    [router]
  );

  return (
    <SMLContainer
      header={
        <ChartsPageHead tab={SMLRouteNames.tracks}>
          <SMLDatePicker />
        </ChartsPageHead>
      }
    >
      <PageTabsInBody>
        <ChartsTabRow screen={SMLRouteNames.tracks} />
      </PageTabsInBody>
      <Row className="mb-4">
        <Col xs={12} lg={8}>
          <TrackSearchField
            placeholder={intl.formatMessage({
              id: 'app.search.tracks.placeholder',
              defaultMessage: 'Search for tracks...',
            })}
            onTrackSelected={handleTrackSelected}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} xl={6} className="pb-4">
          <TopGainingTracksCard />
        </Col>
        <Col xs={12} xl={6} className="pb-4">
          <TopOverallTracksCard />
        </Col>
      </Row>
    </SMLContainer>
  );
};

export const SMLTracksHome = TypedMemo(SMLTracksHomeComponent);
